export enum IconSize {
  EXTRA_LARGE = 'xl',
  EXTRA_SMALL = 'xs',
  LARGE = 'l',
  MEDIUM = 'm',
  SMALL = 's',
}

export enum IconRotation {
  NONE = '0',
  CW_90 = '90',
  CW_180 = '180',
  CW_270 = '270',
  CCW_90 = '-90',
  CCW_180 = '-180',
  CCW_270 = '-270',
}
